var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEdit = function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.443 5.025H4.985a3.383 3.383 0 0 0-3.383 3.383v18.608A3.383 3.383 0 0 0 4.985 30.4h18.608a3.383 3.383 0 0 0 3.384-3.384v-8.458M24.585 2.633a3.384 3.384 0 1 1 4.784 4.784L14.844 21.94H10.06v-4.784z"
  })));
};
export default SvgIconEdit;